import {useDispatch} from 'react-redux';

import React, {useRef, forwardRef, Ref, useImperativeHandle, useEffect} from 'react'

import {useTypedSelector} from '../../../../../../hooks/useTypeSelector';

import {FlyerPageDto, FlyerPageSpotDto, PopupSettings} from '../../../../../../dtos'
import Canvas, {ICanvasRef} from '../../../../../../com/canvas/Canvas'

import Loader from '../../../../../../com/loader/Loader'

import {Spots} from '../../../../../com/canvas/spots/Spots'

import './FlyerPage.scss'
import {useState} from 'react'
// import {ReactComponent as ImageWithError} from "../../../../../../assets/editors/image_with_error.svg";


import {
    EVENT_TYPE_READY_FOR_SPOTS_PERSISTENCY_SAVE,

    addEventTypeListener,
    removeEventTypeListener
} from '../../../../../../globals/EventDispatcher'
import {
    FLYER_CANVAS_HEIGHT,
    FLYER_CANVAS_WIDTH,
    getCanvasSize, getCanvasWrapperSize,
    updateCanvasSize
} from '../../../../../../globals';
import {getFlippingFlyer} from "../../../../../../store";
import {AsyncImageWithLoader} from "../../../../../../com/imageWithLoader/imageWithLoader";
import StatusPopup from "../../../../../../com/statusPopup/StatusPopup";
import {ActionType} from "../../../../../../store/actionTypes";
import {getSettingsForPopup} from "../../../../pages/getSetttingsForPopup";
import {getIconStyle} from "../../../../../../globals/globFunctions";

export interface IFlyerPageRef {
    setNextGridSize: (rows: number, columns: number) => void;
    reInit: () => void;
    showLoader: (value: boolean) => void;
}

export interface IFlyerPage {
    data?: FlyerPageDto,
    isDisabledZoom: boolean;
    selectedFrames: FlyerPageSpotDto[];
    setSelectedFrames: (frames: FlyerPageSpotDto[]) => void;
}


export const FlyerPage = forwardRef((props: IFlyerPage, ref: Ref<IFlyerPageRef>) => {

    const dispatch = useDispatch();

    let flippingFlyerState = useTypedSelector((state) => state.flippingFlyer);
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const flyerIconStyleType = flyerDetailsState.flyGusRec?.gusIconContrast || 1;
    const iconStyleData = getIconStyle(flyerIconStyleType);
    const {toggleActionsForFlyers} = useTypedSelector((state) => state);

    let spotsState = useTypedSelector((state) => state.spots);

    useImperativeHandle(ref, () => ({
        reInit,
        showLoader,
        setNextGridSize,
    }));

    const timer = useRef<NodeJS.Timeout | undefined>();
    const canvasRef = useRef<ICanvasRef>(null);

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isModalPopup, setModalPopup] = useState<boolean>(false);
    const [popupSettings, setPopupSettings] = useState<PopupSettings>({})

    let canvasWidth = FLYER_CANVAS_WIDTH;
    let canvasHeigth = FLYER_CANVAS_HEIGHT;

    const spots = useRef<Spots | null>(null)
    if (spots.current === null) {
        spots.current = new Spots(true, canvasWidth, canvasHeigth, flyerDetailsState.flyFstRec.fstCaption !== "Published", props.isDisabledZoom, iconStyleData)
    }

    const reInit = () => {
        dispose();
        // init
        spots.current = new Spots(true, canvasWidth, canvasHeigth, flyerDetailsState.flyFstRec.fstCaption !== "Published", props.isDisabledZoom, iconStyleData);
    }

    const dispose = () => {

        if (spots.current) {
            spots.current!.dispose();
            if (spots.current!.parent) {
                spots.current!.parent.removeChild(spots.current!)
            }
            spots.current = null;
        }

        if (canvasRef.current) {
            canvasRef.current.reInitCanvas();
        }
    }

    const showLoader = (value: boolean) => {
        setIsLoading(value)
    }

    const setNextGridSize = (rows: number, columns: number) => {
        spots.current!.setNextGgridSize(rows, columns)
    }

    const handlePresistency = () => {
        if (spots.current) {
            let flyerPageDto = spots.current.flyerPageDto!;
            spots.current.persistenceManager?.save(flyerPageDto.flpRecId!, dispatch, flyerPageDto);
        }
    }

    const reInitCanvas = () => {
        if (props.data !== null && canvasRef.current && props.data?.flyerPageSpots) {

            reInit();
            const {containerWidth, containerHeight} = getCanvasWrapperSize();
            let canvasDimensions = getCanvasSize(props.data!.flpWidthPx!, props.data!.flpHeightPx!, toggleActionsForFlyers.isZoomIn, containerWidth, containerHeight)

            updateCanvasSize(
                spots.current!,
                props.data!.flpWidthPx!,
                props.data!.flpHeightPx!,
                toggleActionsForFlyers.isZoomIn
            )

            // IMPORTANT:
            // ----------
            // this props.data is a FlyerPageDto dto and is comming from the flyer reducer so
            // since we handle its internal content inside spots its values will persist from
            // page to page.
            spots.current!.initSpotsDtos(props.data!, canvasDimensions.width, canvasDimensions.height, spotsState.isHorizontalOrientationForFrames, spotsState.isSelectAll, props.selectedFrames)
            // spots.current!.initSpotsDtos(props.data!, originalDimensions.originalWidth, originalDimensions.originalHeight)
            canvasRef.current?.addChild(spots.current!);
        }

    }

    useEffect(() => {
        if (props.data !== null && canvasRef.current && props.data?.flyerPageSpots) {

            if (timer.current) {
                clearTimeout(timer.current)
            }

            timer.current = setTimeout(() => {
                setIsLoading(false);
            }, 2000);
            reInitCanvas();
        } else {
            canvasRef.current?.addChild(spots.current!);
        }

        return () => {
            if (timer.current) {
                clearTimeout(timer.current)
            }
        };

    }, [props.data, props.isDisabledZoom, toggleActionsForFlyers.isZoomIn]);

    useEffect(() => {
        window.addEventListener('resize', reInitCanvas);
        return() => {
            window.removeEventListener('resize', reInitCanvas);
        }
    }, [props.data]);

    useEffect(() => {
        if (flippingFlyerState.type === ActionType.POST_FLYER_SPOTS_SUCCESS
        ) {
            if (flippingFlyerState.type === ActionType.POST_FLYER_SPOTS_SUCCESS) {
                let message = [];
                let modalName = `successfullyUpload`;
                if (flippingFlyerState.successInfo && flippingFlyerState.successInfo.severityLevel === 'Info') {
                    message = flippingFlyerState.successInfo.userFriendlyMessage.split(`\r\n`)
                        .filter(key => key !== '');
                    modalName = `successfullyUploadWithSomeErrors`;
                } else {
                    message.push(`Frames uploaded successfully`);
                }
                setPopupSettings({
                        typeStatus: 0,
                        title: '',
                        subTitle: '',
                        messages: message,
                        modalName: modalName,
                    }
                )
            }
            setModalPopup(true);
        }

        setIsLoading(flippingFlyerState.loading)
    }, [flippingFlyerState.loading])

    useEffect(() => {

        if (spotsState.type === "POST_FLYER_SPOTS_DELETE_SUCCESS") {
            // if(spotsState.type === "POST_FLYER_SPOTS_DELETE_SUCCESS" || spotsState.type === "POST_FLYER_SPOTS_CREATE_SUCCESS"){
            dispatch(getFlippingFlyer(props.data!.flpFlyRecId!))
        } else if (spotsState.loading === true) {
            showLoader(true)
        } else {
            if (spotsState.type?.includes('SUCCESS')) {
                if (spots.current && spots.current.flyerPageDto) {
                    const newSelectedFramesState: FlyerPageSpotDto[] = [];
                    spotsState.spots?.forEach((frame: FlyerPageSpotDto) => {
                        const findUpdateFrameInSelectedFrames = props.selectedFrames.find((selectedFrame: FlyerPageSpotDto) => frame.fpsPositionNo === selectedFrame.fpsPositionNo);
                        if (findUpdateFrameInSelectedFrames) {
                            newSelectedFramesState.push({
                                ...frame,
                                fpsX0px: findUpdateFrameInSelectedFrames.fpsX0px,
                                fpsY0px: findUpdateFrameInSelectedFrames.fpsY0px
                            })
                        }
                    });
                    if (newSelectedFramesState.length) {
                        props.setSelectedFrames(newSelectedFramesState)
                    }
                    spots.current!.updateSpotsDtos(spotsState.spots!);
                }

                setTimeout(() => {
                    showLoader(false)
                }, 100);
            } else if (spotsState.type?.includes('ERROR')) {
                showLoader(false)
            }

        }
    }, [spotsState])

    useEffect(() => {
        addEventTypeListener(EVENT_TYPE_READY_FOR_SPOTS_PERSISTENCY_SAVE, handlePresistency)

        return () => {
            // on unmount

            removeEventTypeListener(EVENT_TYPE_READY_FOR_SPOTS_PERSISTENCY_SAVE);

            dispose();
        }
    }, []);

    let settingsForPopup = getSettingsForPopup(popupSettings);
    return (
        <div className="flyer_page_container">
            <AsyncImageWithLoader src={props.data?.flpImageUrl ? props.data?.flpImageUrl : ''} withoutLoader={true}/>
            <Canvas ref={canvasRef} id={'cavansTest'} width={canvasWidth} height={canvasHeigth}/>

            {isLoading &&
                <div className="flyer_page_container_loader">
                    <Loader show={isLoading}/>
                </div>
            }
            {isModalPopup && <StatusPopup
                settings={settingsForPopup}
                type={settingsForPopup.typeStatus ? settingsForPopup.typeStatus : 0}
                title={settingsForPopup.title ? settingsForPopup.title : 'SUCCESS'}
                subTitle={''}
                messages={settingsForPopup.messages}
                show={isModalPopup}
                handleClose={() => setModalPopup(false)}
            />
            }
        </div>
    )
})
